import React from "react";
import Link from "next/link";
import Router from "next/router";
import { Trans, useTranslation } from "next-i18next";

import openChatModal from "@sellernote/shared/src/services/chat/openChatModal";
import { getCompanyPhoneNumber } from "@sellernote/features/src/common/constants/common";
import TextButton from "@sellernote/ui/src/sds-v1/components/button/TextButton";
import Icon from "@sellernote/ui/src/sds-v1/components/Icon";
import { COLOR } from "@sellernote/ui/src/sds-v1/styles/constants";

import SupportMenuSection from "./SupportMenuSection";
import Styled from "./index.styles";

export default function SupportSideMenu({
  boardType,
}: {
  boardType?: "guide";
}) {
  const { t } = useTranslation(["support-new"]);

  return (
    <Styled.container>
      <Styled.supportMenu>
        <h5 className="side-menu-title">
          {t("support-new:공통_고객지원_안내")}
        </h5>

        <SupportMenuSection
          desc={<Trans i18nKey="support-new:공통_문의_안내" />}
          button={{
            label: t("support-new:공통_문의하기_버튼"),
            handleClick: openChatModal,
          }}
        />

        {/** KR쉽다에서는 영상 페이지로 안내, SG쉽다에서는 비즈니스 일정 조율 서비스로 안내 */}
        <SupportMenuSection
          desc={<Trans i18nKey="support-new:공통_영상_안내" />}
          button={{
            label: t("support-new:공통_영상_소개_활용_동영상_버튼"),
            handleClick: () => {
              Router.push({
                pathname: "/support/onlinelecture",
              });
            },
          }}
        />

        {/* 가이드 북 페이지 완성 후 공개 <SupportMenuSection
          desc={
            <>
              운송수단 및 무역조건별 프로세스 및 쉽다
              <br />
              이용방법이 정리된 가이드북을 신청하세요.
            </>
          }
          button={{
            label: "가이드북 신청",
            handleClick: () => {},
          }}
        /> */}

        <Styled.supportMenuSectionContainer>
          <SupportMenuSection
            desc={
              <>
                <span className="bullet">&#9642;</span>
                {t("support-new:공통_대표번호")}
              </>
            }
            button={{
              label: getCompanyPhoneNumber(),
              handleClick: () => Router.push(`tel:${getCompanyPhoneNumber()}`),
              iconType: "call",
            }}
          />

          <SupportMenuSection
            desc={
              <>
                <span className="bullet">&#9642;</span>
                {t("support-new:공통_이메일")}
              </>
            }
            button={{
              label: "cs@ship-da.com",
              handleClick: () => Router.push("mailto:cs@ship-da.com"),
              iconType: "email",
            }}
          />
        </Styled.supportMenuSectionContainer>
      </Styled.supportMenu>

      {boardType !== "guide" && (
        <>
          <Styled.dividingMiddleLine>
            <div className="line" />
            <span className="or-text">{t("support-new:공통_또는")}</span>
            <div className="line" />
          </Styled.dividingMiddleLine>
          <Styled.guideMenu>
            <h5 className="side-menu-title">{t("support-new:공통_가이드")}</h5>

            <p className="desc">{t("support-new:공통_궁금한_사항_안내")}</p>

            <Styled.guideMenuList>
              <li>
                <Link href="/support/guide/use">
                  <a>
                    <div className="icon-wrapper">
                      <Icon type="book" size={2} color={COLOR.grayScale_500} />
                    </div>

                    <TextButton
                      theme="default"
                      label={t("support-new:공통_이용방법")}
                      size="12px"
                    />
                  </a>
                </Link>
              </li>

              <li>
                <Link href="/support/guide/tradeterms">
                  <a>
                    <div className="icon-wrapper">
                      <Icon type="words" size={2} color={COLOR.grayScale_500} />
                    </div>

                    <TextButton
                      theme="default"
                      label={t("support-new:공통_무역용어_운송프로세스")}
                      size="12px"
                    />
                  </a>
                </Link>
              </li>

              <li>
                <Link href="/support/guide/faq">
                  <a>
                    <div className="icon-wrapper">
                      <Icon type="solve" size={2} color={COLOR.grayScale_500} />
                    </div>

                    <TextButton theme="default" label="FAQ" size="12px" />
                  </a>
                </Link>
              </li>
            </Styled.guideMenuList>
          </Styled.guideMenu>
        </>
      )}
    </Styled.container>
  );
}
